import styled from 'styled-components';
import { ContinueCTAButtonTemplate } from './ContinueCTAButtonTemplate';

export const ContinueCTAButton = styled(ContinueCTAButtonTemplate)`
    
`;
